export const BADGES_REQUEST = "BADGES_REQUEST";
export const BADGES_SUCCESS = "BADGES_SUCCESS";
export const BADGES_FAILURE = "BADGES_FAILURE";